import React, { useEffect, useState } from "react";

import { loadStyles } from "../../utils/cssLoader";

const CricketPlayerStats = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState("all");
  const [selectedType, setSelectedType] = useState("batting");

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketplayer");
    }
  }, [loadCSS]);

  const data = dataClient ? clientData : ServerData;
  const statsData = data?.data;

  if (!statsData || statsData.length === 0) {
    return (
      <div className="cricket-player-stats">
        <div className="no-data-message">{dictionary?.noStats || "No statistics available"}</div>
      </div>
    );
  }

  const battingStats = statsData[0]?.batting_stats || [];
  const bowlingStats = statsData[1]?.bowling_stats || [];

  // Get unique formats
  const formats = ["all", ...new Set(battingStats.map((stat) => stat.for))];

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  // Filter stats based on selected format
  const getFilteredStats = (stats) => {
    if (selectedFormat === "all") return stats;
    return stats.filter((stat) => stat.for === selectedFormat);
  };

  const filteredBattingStats = getFilteredStats(battingStats);
  const filteredBowlingStats = getFilteredStats(bowlingStats);

  const renderBattingTable = () => (
    <div className="stats-table-wrapper">
      <table className="stats-table">
        <thead>
          <tr>
            <th>{dictionary?.format || "Format"}</th>
            <th>{dictionary?.mat || "Mat"}</th>
            <th>{dictionary?.inn || "Inn"}</th>
            <th>{dictionary?.no || "NO"}</th>
            <th>{dictionary?.runs || "Runs"}</th>
            <th>{dictionary?.hs || "HS"}</th>
            <th>{dictionary?.avg || "Avg"}</th>
            <th>{dictionary?.sr || "SR"}</th>
            <th>{dictionary?.hundreds || "100s"}</th>
            <th>{dictionary?.fifties || "50s"}</th>
            <th>{dictionary?.fours || "4s"}</th>
            <th>{dictionary?.sixes || "6s"}</th>
            <th>{dictionary?.ct || "Ct"}</th>
            <th>{dictionary?.st || "St"}</th>
          </tr>
        </thead>
        <tbody>
          {filteredBattingStats.map((stat, index) => (
            <tr key={index}>
              <td className="format-cell">{formatValue(stat.for)}</td>
              <td>{formatValue(stat.mats)}</td>
              <td>{formatValue(stat.inn)}</td>
              <td>{formatValue(stat.nots)}</td>
              <td className="highlight-cell">{formatValue(stat.runs)}</td>
              <td>{formatValue(stat.hsco)}</td>
              <td className="highlight-cell">{formatValue(stat.bavg)}</td>
              <td>{formatValue(stat.srate)}</td>
              <td>{formatValue(stat.cen)}</td>
              <td>{formatValue(stat.fif)}</td>
              <td>{formatValue(stat.four)}</td>
              <td>{formatValue(stat.six)}</td>
              <td>{formatValue(stat.cats)}</td>
              <td>{formatValue(stat.stps)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderBowlingTable = () => (
    <div className="stats-table-wrapper">
      <table className="stats-table">
        <thead>
          <tr>
            <th>{dictionary?.format || "Format"}</th>
            <th>{dictionary?.mat || "Mat"}</th>
            <th>{dictionary?.inn || "Inn"}</th>
            <th>{dictionary?.balls || "Balls"}</th>
            <th>{dictionary?.runs || "Runs"}</th>
            <th>{dictionary?.wkts || "Wkts"}</th>
            <th>{dictionary?.bbi || "BBI"}</th>
            <th>{dictionary?.bbm || "BBM"}</th>
            <th>{dictionary?.avg || "Avg"}</th>
            <th>{dictionary?.econ || "Econ"}</th>
            <th>{dictionary?.sr || "SR"}</th>
            <th>{dictionary?.fourW || "4w"}</th>
            <th>{dictionary?.fiveW || "5w"}</th>
            <th>{dictionary?.tenW || "10w"}</th>
          </tr>
        </thead>
        <tbody>
          {filteredBowlingStats.map((stat, index) => (
            <tr key={index}>
              <td className="format-cell">{formatValue(stat.for)}</td>
              <td>{formatValue(stat.mats)}</td>
              <td>{formatValue(stat.inn)}</td>
              <td>{formatValue(stat.bal)}</td>
              <td>{formatValue(stat.runs)}</td>
              <td className="highlight-cell">{formatValue(stat.wkts)}</td>
              <td>{formatValue(stat.bbowinn)}</td>
              <td>{formatValue(stat.bbowlingmat)}</td>
              <td className="highlight-cell">{formatValue(stat.boavg)}</td>
              <td>{formatValue(stat.erate)}</td>
              <td>{formatValue(stat.bostkrat)}</td>
              <td>{formatValue(stat.wkt4)}</td>
              <td>{formatValue(stat.wkt5)}</td>
              <td>{formatValue(stat.wkt10)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      {title && <h1>{title}</h1>}
      <div className="cricket-player-stats">
        <div className="stats-card">
          <div className="stats-card-header">
            <h3 className="stats-title">{dictionary?.careerStats || "Career Statistics"}</h3>
            <div className="stats-filters">
              <div className="filter-group">
                <select
                  className="stats-dropdown"
                  value={selectedFormat}
                  onChange={(e) => setSelectedFormat(e.target.value)}
                >
                  {formats.map((format) => (
                    <option key={format} value={format}>
                      {format === "all" ? (dictionary?.allFormats || "All Formats") : format}
                    </option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <select
                  className="stats-dropdown"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="batting">{dictionary?.batting || "Batting"}</option>
                  <option value="bowling">{dictionary?.bowling || "Bowling"}</option>
                </select>
              </div>
            </div>
          </div>

          <div className="stats-card-body">
            {selectedType === "batting" ? renderBattingTable() : renderBowlingTable()}
          </div>
        </div>
      </div>
    </>
  );
};

export default CricketPlayerStats;
